import { render, staticRenderFns } from "./BARatingChip.vue?vue&type=template&id=000be5a4&"
import script from "./BARatingChip.vue?vue&type=script&lang=ts&"
export * from "./BARatingChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports